import LegalPage from "../../components/legal/LegalPage";
import document from "../../content/legal/cookies-policy.json";

export default function Page() {
  return <LegalPage title="Cookie Policy" document={document} />;
}
